<style lang="scss">
    .group-info-page-ui {
        .page-info-item {
            margin-bottom: 10px;
            .ivu-card-body > h3 {
                padding: 10px 15px 0;
            }
        }
    }
</style>

<template>
    <div class="group-info-page-ui">
        <div v-for="(item, k) in orderedInfoItems" :key="k">
            <Card :padding="0" class="page-info-item" shadow>
                <h3>{{item.title}}</h3>
                <div 
                    class="compound-text" 
                    v-html="contentDisplay(item)">
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
import _get from "lodash/get"
import _orderBy from "lodash/orderBy"

export default {
    props: {
        pages: {
            type: [Array, Object],
            required: true
        }
    },
    computed: {
        orderedInfoItems() {
            return _orderBy(this.pages, "order", "asc");
        }
    },
    methods: {
        contentDisplay (act) {
            switch (act.type) {
                case 'user_post':
                    return _get(act, "data.text", "")  
                    break
                case 'attachment':
                    if (act.data) {
                        switch (act.data.attachment_type) {
                            case 'video':
                                return _get(act, "data.text") ? _get(act, "data.text") : _get(act, "data.preview_summary");
                                break
                            case 'link':
                                return _get(act, "data.text") ? _get(act, "data.text") : _get(act, "data.preview_summary");
                                break
                            default:
                                return _get(act, "data.text", "")                    
                                break
                        }
                    }
                    break
                case 'trivia':
                    return _get(act, "data.question", "")                    
                    break
                case 'reveal':
                    if (act.data && act.data.question) return act.data.question
                    return _get(act, "data.question", "")                    
                    break
                case 'video':
                    return _get(act, "data.text", "")
                    break
                default:
                    return _get(act, "data.tip", "")
                    break
            }
            return ''
        },
    }
}
</script>